import {createSelector} from 'reselect';

import getFeatureSource from './get-feature-source';

export default createSelector([getFeatureSource], (featureSource) =>
	featureSource.data.features.filter((feature) => feature.properties.isActive)
);
